import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StatelessPopup } from 'components/popup/stateless_popup/StatelessPopup';
import { FavoritesMenu } from 'components/top_bar/FavoritesMenu';
import { usePopup } from 'custom_hooks/usePopup';
import { MenuButton } from 'styles/theme_styles/button';

export type FavoritesPopupProps = Readonly<{
    corporationId?: string;
    locationId?: string;
}>;
export function FavoritesPopup({ corporationId, locationId }: FavoritesPopupProps) {
    const { isOpen, toggleOpen, close, triggerRef, popupRef } = usePopup<
        HTMLButtonElement,
        HTMLDivElement
    >({
        closeOnClickOutside: true,
    });

    return (
        <>
            <MenuButton
                aria-label="Open Favorites Menu"
                onClick={toggleOpen}
                $active={isOpen}
                ref={triggerRef}
            >
                <FontAwesomeIcon icon={faStar} />
            </MenuButton>
            {isOpen && (
                <StatelessPopup
                    noPadding
                    popupClassName="menu-max-height"
                    onClose={close}
                    anchor={triggerRef.current}
                    ariaLabel="Favorites Menu"
                    ref={popupRef}
                    noOverlay
                >
                    <FavoritesMenu
                        corporationId={corporationId}
                        locationId={locationId}
                        onClose={close}
                    />
                </StatelessPopup>
            )}
        </>
    );
}
